var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.125C2 3.77969 2.27984 3.5 2.625 3.5H18.875C19.2188 3.5 19.5 3.77969 19.5 4.125C19.5 4.47031 19.2188 4.75 18.875 4.75H2.625C2.27984 4.75 2 4.47031 2 4.125ZM2 10.375C2 10.0312 2.27984 9.75 2.625 9.75H18.875C19.2188 9.75 19.5 10.0312 19.5 10.375C19.5 10.7188 19.2188 11 18.875 11H2.625C2.27984 11 2 10.7188 2 10.375ZM18.875 17.25H2.625C2.27984 17.25 2 16.9688 2 16.625C2 16.2812 2.27984 16 2.625 16H18.875C19.2188 16 19.5 16.2812 19.5 16.625C19.5 16.9688 19.2188 17.25 18.875 17.25Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.c2d649fc70944d8b30ec18df53e23a9d.svg";
export { ForwardRef as ReactComponent };